<template>
	<form @submit.prevent="onSubmit" novalidate>
		<slot :meta="meta" :submitting="submitting" :success="success" :error="error"></slot>
	</form>
</template>

<script setup>
import { ref, watch } from 'vue';
import { useForm } from 'vee-validate';
import { useFormspark } from "@formspark/vue-use-formspark";

const props = defineProps({
	formId: String,
	formHandle: String
});

const { meta, handleSubmit, resetForm } = useForm();

watch(() => meta.value.touched, (newVal) => {
	if (newVal === true) {
		if (window.plausible) window.plausible(props.formHandle + ': Initiated');
	}
}, { deep: true });

const [submit, submitting] = useFormspark({
	formId: props.formId
});

const success = ref(false);
const error = ref(false);

const onSubmit = handleSubmit(async values => {
	success.value = false;
	error.value = false;
	try {
		await submit(values);
		success.value = true;
		if (window.plausible) window.plausible(props.formHandle + ': Sent');
		resetForm();
	} catch (err) {
		error.value = true;
		if (window.plausible) window.plausible(props.formHandle + ': Failed');
		console.error(err.message || 'An error occurred during submission');
	}
});
</script>
